import { render, staticRenderFns } from "./MobileMenuButton.vue?vue&type=template&id=c801e774&"
import script from "./MobileMenuButton.vue?vue&type=script&lang=js&"
export * from "./MobileMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports